import { Button, Popover, Stack, TextField } from '@mui/material';
import type { Editor } from '@provision/rich-text-editor';
import { useState } from 'react';

interface LinkPopoverProps {
  editor: Editor;
  open: boolean;
  onClose: () => void;
}

export const LinkPopover = ({ editor, open, onClose }: LinkPopoverProps) => {
  const [href, setHref] = useState('');
  const anchor = open ? editor.view.coordsAtPos(editor.state.selection.from) : null;

  const close = () => {
    setHref('');
    onClose();
  };

  const apply = () => {
    const url = href.trim();

    if (url) {
      editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({ href: /^[a-z][a-z\d+.-]*:/i.test(url) ? url : `https://${url}` })
        .run();
    }

    close();
  };

  return (
    <Popover
      open={open}
      onClose={close}
      anchorReference="anchorPosition"
      anchorPosition={anchor ? { top: anchor.bottom + 8, left: anchor.left } : undefined}
    >
      <Stack direction="row" gap={1} p={1.5}>
        <TextField
          autoFocus
          size="small"
          placeholder="https://"
          value={href}
          onChange={(event) => setHref(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') apply();
          }}
          inputProps={{ 'aria-label': 'Link address' }}
        />
        <Button variant="contained" size="small" onClick={apply}>
          Add
        </Button>
      </Stack>
    </Popover>
  );
};
